"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (module) {
    module.factory('pr.dataRequestService', [
        '$http',
        'pr.httpPostCache',
        'pr.API_ROUTES',
        'prSourceDataService',
        'pr.globalOptionsService',
        'prActiveReport',
        '$q',
        'pr.bulkFieldService',
        'pr.timezoneUtil',
        'rsEnvironment',
        'prDynamicTranslationsUtil',
        'pr.displayLogicParamsManager',
        'prSnapshot',
        function (
        // @ts-ignore
        $http, 
        // @ts-ignore
        httpPostCache, 
        // @ts-ignore
        API_ROUTES, 
        // @ts-ignore
        sourceData, 
        // @ts-ignore
        goService, 
        // @ts-ignore
        activeReport, 
        // @ts-ignore
        $q, 
        // @ts-ignore
        bulkFieldService, 
        // @ts-ignore
        timezoneUtil, 
        // @ts-ignore
        env, 
        // @ts-ignore
        dynamicTranslationsUtil, displayLogicParamsManager, snapshotService) {
            /**
             * Constructs the path to hit to retrieve data.
             *
             * @param {DataRequestType} requestType
             * @param {SourceId} sourceId
             */
            function getPath(requestType, sourceId) {
                var path = API_ROUTES.DATA;
                if (sourceId) {
                    var sourceType = sourceData.getSourceType(sourceId);
                    path += sourceType + '/' + sourceId + '/';
                }
                path += requestType;
                return path;
            }
            /**
             * Attaches information that is necessary for all data requests
             * which cannot be determined on the server. Also attaches any
             * information that is relevant to determine whether the data
             * retrieval cache should be used.
             *
             * @param  {Partial<DataRequestOptions>} requestOptions - request options generated by the caller
             * @return {DataRequestOptions} modified requestOptionsObject
             */
            function generateOptions(requestOptions, extraOptions) {
                if (extraOptions === void 0) { extraOptions = {}; }
                var privateExportContextMeta = env.get(environment_1.ENV_VARS.PRIVATE_EXPORT_META);
                var orgHierarchyId = lodash_1.default.get(privateExportContextMeta, 'activeOrgHierarchyId');
                var widgetId = extraOptions.widgetId;
                return lodash_1.default.assign({}, requestOptions, {
                    dataRequestParams: {
                        activeSurveyId: env.get(environment_1.ENV_VARS.RS_ACTIVE_SURVEY),
                        activeReportId: activeReport.getReportId(),
                        bulkFieldOptions: bulkFieldService.getConfig(),
                        // @ts-ignore
                        displayLogicRequestParams: displayLogicParamsManager.getDisplayLogicRequestParams(widgetId),
                        orgHierarchyId: orgHierarchyId || env.get(environment_1.ENV_VARS.ORG_HIERARCHY_ID),
                        sourceIdToSnapshotIdMap: snapshotService.getSourceIdToSnapshotIdMap(),
                        timezone: timezoneUtil.standardizeTimezone(goService.getTimezone()),
                        widgetId: widgetId
                    }
                });
            }
            /**
             * A wrapper for http post requests to the /data route.
             * Will use the http cache if necessary.
             *
             * @param {DataRequestOptions} requestOptions - options to send over the network to prs
             * @param {string} requestType - must be 'aggregate', 'records' or 'wordcount'
             * @param {object|undefined} [extraOptions] - some additional optional parameters:
             * 		@param {string} [extraOptions.sourceId] - not included for metric widget data requests
             * 		@param {boolean} [extraOptions.useCache] - only flagged for data component requests
             */
            function post(requestOptions, requestType, extraOptions) {
                if (extraOptions === void 0) { extraOptions = {}; }
                if (!lodash_1.default.isObject(requestOptions) || !requestType) {
                    throw new Error('Either no options object passed or no request type passed');
                }
                try {
                    requestOptions = generateOptions(requestOptions, extraOptions);
                    var httpService = extraOptions.useCache ? httpPostCache : $http;
                    // @ts-ignore
                    var path = getPath(requestType, extraOptions.sourceId);
                    var config = dynamicTranslationsUtil.getLanguageHeaders();
                    return httpService.post(path, requestOptions, config);
                }
                catch (error) {
                    console.error(error);
                    throw error;
                }
            }
            return {
                generateOptions: generateOptions,
                post: post,
                __TESTING__: {
                    // for unit testing
                    getPath: getPath
                }
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
